import React from "react";
import { MessageSquare } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";

// Color Selection Modal for Roof Wrap and Chrome Delete
const ColorSelectionModal = ({ isOpen, onClose, service, onSelectGlossBlack, onSelectCustom }) => {
  if (!service) return null;
  
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-saturn-slate border-slate-700 text-white max-w-md">
        <DialogHeader>
          <DialogTitle className="font-orbitron text-xl text-white">
            {service.name} - Select Color
          </DialogTitle>
          <DialogDescription className="text-slate-400">
            Choose your preferred finish option
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex flex-col gap-4 mt-4">
          <button
            onClick={onSelectGlossBlack}
            className="glass rounded-xl p-4 text-left hover:border-saturn-orange transition-all group"
            data-testid="color-modal-gloss-black"
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-rajdhani font-bold text-white group-hover:text-saturn-orange">
                  Gloss Black
                </h4>
                <p className="text-slate-400 text-sm mt-1">Standard finish - Book now</p>
              </div>
              <div className="text-right">
                <span className="text-saturn-orange font-orbitron font-bold text-lg">
                  EUR{service.base_price}
                </span>
                <p className="text-slate-500 text-xs">Fixed price</p>
              </div>
            </div>
          </button>
          
          <button
            onClick={onSelectCustom}
            className="glass rounded-xl p-4 text-left hover:border-blue-500 transition-all group"
            data-testid="color-modal-custom"
          >
            <div className="flex items-center justify-between">
              <div>
                <h4 className="font-rajdhani font-bold text-white group-hover:text-blue-400">
                  Custom Color
                </h4>
                <p className="text-slate-400 text-sm mt-1">Request a personalized quote</p>
              </div>
              <div className="text-right">
                <span className="text-blue-400 font-rajdhani font-bold flex items-center gap-1">
                  <MessageSquare className="w-4 h-4" />
                  Get Quote
                </span>
                <p className="text-slate-500 text-xs">Contact us</p>
              </div>
            </div>
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ColorSelectionModal;
